import { Divider } from "components/design/Divider";
import { Button } from "components/DesignSystem/Button/Button";
import { PaperPlaneSkyblue } from "components/icons/PaperPlaneSkyblue";
import { UnhappyCloud } from "components/icons/UnhappyClud";

export const SubscriptionEmptyState = ({
  onUpgrade,
}: {
  onUpgrade: () => void;
}) => {
  return (
    <div className="t-flex t-flex-col t-gap-2">
      <div className="t-flex t-items-center t-text-neutral-50 t-gap-5">
        <div className="t-text-caption">SOFTWARE SUBSCRIPTION</div>
        <div className="t-w-1/2">
          <Divider />
        </div>
      </div>
      <div className="t-flex t-flex-col t-items-center  t-gap-2 t-px-3 t-py-2 t-border t-border-solid t-border-neutral-0 t-rounded-lg">
        <PaperPlaneSkyblue height="24" width="24" />
        <div className="t-text-subtext-sm t-text-text-60">
          You are on Free Plan
        </div>
        <div className="t-text-body-sm t-text-neutral-50 t-text-center">
          Upgrade to Standard Plan to get everything in Free plan plus premium
          features to boost your accounting needs
        </div>
        <Button
          size="small"
          color="blue"
          customType="primary"
          onClick={onUpgrade}
        >
          <div className="t-text-subtext-sm">Upgrade to Standard</div>
        </Button>
      </div>
    </div>
  );
};

export const BookkeepingEmptyState = ({
  onExplore,
}: {
  onExplore: () => void;
}) => {
  return (
    <div className="t-flex t-flex-col t-gap-2">
      <div className="t-flex t-items-center t-text-neutral-50 t-gap-5">
        <div className="t-text-caption">BOOKKEEPING SUBSCRIPTION</div>
        <div className="t-w-1/2">
          <Divider />
        </div>
      </div>
      <div className="t-flex t-flex-col t-items-center  t-gap-2 t-px-3 t-py-2 t-border t-border-solid t-border-neutral-0 t-rounded-lg">
        <UnhappyCloud />
        <div className="t-text-subtext-sm t-text-text-60">
          No active subscription
        </div>
        <div className="t-text-body-sm t-text-neutral-50 t-text-center">
          Upgrade to our bookkeeping services & get a dedicated bookkeeper to
          manage your annual/monthly financials.
        </div>
        <Button
          size="small"
          color="blue"
          customType="primary"
          onClick={onExplore}
        >
          <div className="t-text-subtext-sm">Explore services</div>
        </Button>
      </div>
    </div>
  );
};
